<template>
	<div class="main-wrapper">
		<CRow>
			<CCol>
				<CInput
					v-model="$v.formData.name.$model"
					:is-valid="!$v.formData.name.$error && null"
					label="Group name*"
					placeholder="e.g. Store staff, Customer support"
					:invalid-feedback="$t('global.error.required')"
				/>
			</CCol>
		</CRow>
		<CRow>
			<CCol>
				<CInput
					v-model="$v.formData.description.$model"
					label="Description"
					placeholder="e.g. Members can manage all the product catalogs"
				/>
			</CCol>
		</CRow>

		<div class="tabs">
			<ul>
				<li :class="['item', {'is-active': activeTab === 0}]" @click="activeTab = 0"><a>Permission Setting</a></li>
				<li :class="['item', {'is-active': activeTab === 1}]" @click="activeTab = 1"><a>PDPA Setting</a></li>
			</ul>
		</div>

		<template v-if="activeTab === 0">
			<!-- PERMISSION -->
			<CRow class="py-2 px-3">
				<CCol :md="permissionLabelMd">
					<div class="label">
						Permission
					</div>
				</CCol>
				<CCol
					v-for="type in permissionTypes"
					:key="type"
					md="2"
				>
					<div class="label">
						{{ permissionTypeLabel(type) }}
					</div>
				</CCol>
			</CRow>
			<CRow class="mb-5">
				<CCol>
					<div class="border border-gray-400 rounded pb-4">
						<CRow>
							<CCol>
								<div class="bg-gray-100">
									<CRow class="py-2">
										<CCol :md="permissionLabelMd">
											<div class="label ml-3">
												Select all
											</div>
										</CCol>
										<CCol
											v-for="type in permissionTypes"
											:key="type"
											md="2"
										>
											<BaseIndeterminateCheckbox
												:checked="isEveryChecked(type)"
												:indeterminate="isIndeterminate(type)"
												:disabled="!hasPermissionType(type)"
												@update:checked="checkPermissions(type, $event)"
											/>
										</CCol>
									</CRow>
								</div>
							</CCol>
						</CRow>
						<CRow>
							<CCol>
								<div
									v-for="(parent, parentIndex) in $v.formData.permissions.$model"
									:key="parentIndex"
									class="roles py-2"
								>
									<CRow>
										<CCol :md="permissionLabelMd">
											<div class="color-black-45 font-weight-normal ml-4">
												<span class="color-gray-900">{{ parent.name }}</span>
												<div v-if="parent.max_days_back != null" class="max-days-back-text">
													(Max {{ parent.max_days_back }} days back)
												</div>
											</div>
										</CCol>
										<template v-if="parent.key">
											<CCol
												v-for="type in permissionTypes"
												:key="type"
												md="2"
											>
												<div>
													<CInputCheckbox
														v-if="parent.permissions[type] !== undefined"
														:checked="parent.permissions[type]"
														custom
														@update:checked="parent.permissions[type] = $event"
													/>
												</div>
											</CCol>
										</template>
										<CCol md="12">
											<CRow
												v-for="(child, childIndex) in parent.children"
												:key="childIndex"
												class="mb-1"
											>
												<CCol :md="permissionLabelMd">
													<div class="ml-3 color-black-45 font-weight-normal ml-5">
														{{ child.name }}
														<div v-if="child.max_days_back != null" class="max-days-back-text">
															(Max {{ child.max_days_back }} days back)
														</div>
													</div>
												</CCol>
												<CCol
													v-for="type in permissionTypes"
													:key="type"
													md="2"
												>
													<div>
														<CInputCheckbox
															v-if="child.permissions[type] !== undefined"
															:checked="child.permissions[type]"
															custom
															@update:checked="child.permissions[type] = $event"
														/>
													</div>
												</CCol>
											</CRow>
										</CCol>
									</CRow>
								</div>
							</CCol>
						</CRow>
					</div>
				</CCol>
			</CRow>
			<!-- END PERMISSION -->
		</template>


		<template v-if="activeTab === 1">
			<!-- PDPA -->
			<CRow class="py-2 px-3">
				<CCol :md="pdpaLabelMd">
					<div class="label">
						PDPA
					</div>
				</CCol>
				<CCol
					v-for="type in pdpaTypes"
					:key="type"
					md="2"
				>
					<div class="label">
						{{ permissionTypeLabel(type) }}
					</div>
				</CCol>
			</CRow>
			<CRow class="mb-5">
				<CCol>
					<div class="border border-gray-400 rounded pb-4">
						<CRow>
							<CCol>
								<div class="bg-gray-100">
									<CRow class="py-2">
										<CCol :md="pdpaLabelMd">
											<div class="label ml-3">
												Select all
											</div>
										</CCol>
										<CCol
											v-for="type in pdpaTypes"
											:key="type"
											md="2"
										>
											<BaseIndeterminateCheckbox
												:checked="isPdpaEveryChecked(type)"
												:indeterminate="isPdpaIndeterminate(type)"
												:disabled="!hasPdpaPermissionType(type)"
												@update:checked="checkPdpa(type, $event)"
											/>
										</CCol>
									</CRow>
								</div>
							</CCol>
						</CRow>
						<CRow>
							<CCol>
								<div
									v-for="(parent, parentIndex) in $v.formData.pdpa.$model"
									:key="parentIndex"
									class="roles py-2"
								>
									<CRow>
										<CCol :md="pdpaLabelMd">
											<div class="color-black-45 font-weight-normal ml-4">
												<span class="color-gray-900">{{ parent.name }}</span>
											</div>
										</CCol>
										<template v-if="parent.key">
											<CCol
												v-for="type in pdpaTypes"
												:key="type"
												md="2"
											>
												<div>
													<CInputCheckbox
														v-if="parent.permissions[type] !== undefined"
														:checked="parent.permissions[type]"
														custom
														@update:checked="parent.permissions[type] = $event"
													/>
												</div>
											</CCol>
										</template>
										<CCol md="12">
											<CRow
												v-for="(child, childIndex) in parent.children"
												:key="childIndex"
												class="mb-1"
											>
												<CCol :md="pdpaLabelMd">
													<div class="ml-3 color-black-45 font-weight-normal ml-5">
														{{ child.name }}
													</div>
												</CCol>
												<CCol
													v-for="type in pdpaTypes"
													:key="type"
													md="2"
												>
													<div>
														<CInputCheckbox
															v-if="child.permissions[type] !== undefined"
															:checked="child.permissions[type]"
															custom
															@update:checked="child.permissions[type] = $event"
														/>
													</div>
												</CCol>
											</CRow>
										</CCol>
									</CRow>
								</div>
							</CCol>
						</CRow>
					</div>
				</CCol>
			</CRow>
			<!-- END PDPA -->
		</template>

		<BaseActionPanelStickyFooter
			:is-edit="isEdit"
			:disabled-confirm="isSubmitting"
			:disabled-cancel="isSubmitting"
			:remove-text="isEdit ? 'Remove group' : null"
			@onCancel="handleCancel"
			@onConfirm="handleConfirm"
			@onRemove="handleRemove"
		/>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { scrollToTop } from '../assets/js/helpers';
import { ROUTE_PERMISSION_KEY, ROUTE_PERMISSION_TYPE } from '../enums/permissions';

const PERMISSION_TYPE_ORDER = ['view', 'manage', 'import', 'export'];
const PERMISSION_TYPE_LABELS = {
	view: 'View',
	manage: 'Manage',
	import: 'Import',
	export: 'Export',
	partial: 'Partial',
	full: 'Full',
};

const deriveTypes = (list) => {
	const types = new Set();
	list.forEach((parent) => {
		if (parent.permissions) Object.keys(parent.permissions).forEach((k) => types.add(k));
		if (parent.children) parent.children.forEach((child) => Object.keys(child.permissions).forEach((k) => types.add(k)));
	});
	return [...types].sort((a, b) => {
		const ia = PERMISSION_TYPE_ORDER.indexOf(a);
		const ib = PERMISSION_TYPE_ORDER.indexOf(b);
		if (ia === -1 && ib === -1) return 0;
		if (ia === -1) return 1;
		if (ib === -1) return -1;
		return ia - ib;
	});
};

export default {
	name: 'FormUserRolePermissionSetting',
	validations: {
		formData: {
			name: {
				required,
			},
			description: {},
			permissions: {},
			pdpa: {},
		},
	},
	props: {
		isEdit: {
			type: Boolean,
			default: false,
		},
		isSubmitting: {
			type: Boolean,
			default: false,
		},
		name: {
			type: String,
			default: null,
		},
		description: {
			type: String,
			default: null,
		},
		permissions: {
			type: Array,
			default: () => [],
		},
		pdpa: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			activeTab: 0,
			formData: {
				name: '',
				description: '',
				permissions: [],
				pdpa: [],
			},
		};
	},
	computed: {
		permissionTypes() {
			return deriveTypes(this.formData.permissions);
		},
		permissionLabelMd() {
			return Math.max(2, 12 - (this.permissionTypes.length * 2));
		},
		pdpaTypes() {
			return deriveTypes(this.formData.pdpa);
		},
		pdpaLabelMd() {
			return Math.max(2, 12 - (this.pdpaTypes.length * 2));
		},
	},
	created() {
		this.formData.name = this.name;
		this.formData.description = this.description;
		this.formData.permissions = this.permissions;
		this.formData.pdpa = this.pdpa;
	},
	methods: {
		permissionTypeLabel(type) {
			return PERMISSION_TYPE_LABELS[type] || (type.charAt(0).toUpperCase() + type.slice(1));
		},

		handleConfirm() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				scrollToTop();
				return;
			}
			this.$emit('onConfirm', {
				name: this.formData.name,
				description: this.formData.description,
				permissions: this.formData.permissions,
				pdpa_permissions: this.formData.pdpa,
			});
		},
		handleCancel() {
			this.$router.push({ name: 'UserRole' });
		},
		handleRemove() {
			this.$emit('onRemove');
		},

		// Permission
		checkPermissions(type, checked) {
			this.permissions.forEach((parentPermission) => {
				if (parentPermission.permissions) {
					if (!parentPermission.permissions.hasOwnProperty(type)) {
						return;
					}

					parentPermission.permissions[type] = checked;
				}

				if (parentPermission.children) {
					parentPermission.children.forEach((childPermission) => {
						if (!childPermission.permissions.hasOwnProperty(type)) {
							return;
						}

						// Fixed manage branch shipment display on role and permission
						if (childPermission.key === ROUTE_PERMISSION_KEY.BRANCH_SHIPMENTS && type === ROUTE_PERMISSION_TYPE.MANAGE) {
							return;
						}

						childPermission.permissions[type] = checked;
					});
				}
			});
		},
		getCheckedState(type) {
			let state = [];
			this.permissions.forEach((parentPermission) => {
				if (parentPermission.permissions) {
					if (!parentPermission.permissions.hasOwnProperty(type)) {
						return;
					}
					state = [
						...state,
						parentPermission.permissions[type],
					];
				}

				if (parentPermission.children) {
					parentPermission.children.forEach((childPermission) => {
						if (!childPermission.permissions.hasOwnProperty(type)) {
							return;
						}
						state = [
							...state,
							childPermission.permissions[type],
						];
					});
				}
			});
			return state;
		},
		isIndeterminate(type) {
			const state = this.getCheckedState(type).filter((s) => s !== undefined);
			return state.some((bool) => bool) && !state.every((bool) => bool);
		},
		isEveryChecked(type) {
			const state = this.getCheckedState(type).filter((s) => s !== undefined);
			return state.length > 0 && state.every((bool) => bool);
		},
		hasPermissionType(type) {
			return this.getCheckedState(type).length > 0;
		},

		// PDPA
		checkPdpa(type, checked) {
			this.pdpa.forEach((parentPdpa) => {
				if (parentPdpa.permissions) {
					if (!parentPdpa.permissions.hasOwnProperty(type)) {
						return;
					}
					parentPdpa.permissions[type] = checked;
				}

				if (parentPdpa.children) {
					parentPdpa.children.forEach((childPermission) => {
						if (!childPermission.permissions.hasOwnProperty(type)) {
							return;
						}
						childPermission.permissions[type] = checked;
					});
				}
			});
		},
		getCheckedStatePdpa(type) {
			let state = [];
			this.pdpa.forEach((parentPdpa) => {
				if (parentPdpa.permissions) {
					if (!parentPdpa.permissions.hasOwnProperty(type)) {
						return;
					}
					state = [
						...state,
						parentPdpa.permissions[type],
					];
				}

				if (parentPdpa.children) {
					parentPdpa.children.forEach((childPermission) => {
						if (!childPermission.permissions.hasOwnProperty(type)) {
							return;
						}
						state = [
							...state,
							childPermission.permissions[type],
						];
					});
				}
			});
			return state;
		},
		isPdpaIndeterminate(type) {
			const state = this.getCheckedStatePdpa(type).filter((s) => s !== undefined);
			return state.some((bool) => bool) && !state.every((bool) => bool);
		},
		isPdpaEveryChecked(type) {
			const state = this.getCheckedStatePdpa(type).filter((s) => s !== undefined);
			return state.length > 0 && state.every((bool) => bool);
		},
		hasPdpaPermissionType(type) {
			return this.getCheckedStatePdpa(type).length > 0;
		},
	},
};
</script>

<style lang="scss" scoped>
.roles {
	font-size: rem($font-size-label);
}

.max-days-back-text {
	font-size: rem(11);
	color: $color-black-45;
	font-weight: normal;
}

.tabs {
	align-items: stretch;
	display: flex;
	justify-content: space-between;
	overflow: hidden;
	overflow-x: auto;
	white-space: nowrap;

	ul {
		align-items: center;
		border-bottom: 1px solid #ddd;
		display: flex;
		flex-grow: 1;
		flex-shrink: 0;
		justify-content: flex-start;
		list-style: none;
		padding-left: 0;
	}

	.item {
		display: block;

		&.is-active {
			> a {
				color: $color-black;
				border-bottom-color: $color-black;
			}
		}

		// normal state
		a {
			cursor: pointer;
			align-items: center;
			border-bottom: 1px solid #ddd;
			display: flex;
			justify-content: center;
			margin-bottom: -1px;
			padding: 8px 16px;
			transition-duration: 150ms;
			transition-property: all;
			vertical-align: top;
			color: $color-black-45;
			font-size: rem(12);
			font-weight: 600;
		}
	}
}
</style>
